export enum UserLocalStorageKey {
  User = 'user',
  GuestLogin = 'guest_login',
  AccessToken = 'access_token',
  TokenExpired = 'token_expired',
  ImpersonateId = 'user_impersonate_user_id',
  UserConfig = 'user_config',
  AccountStatus = 'accountStatus',
  DefaultRoles = 'default_roles',
  Changeuser = 'change_user',
  ContinueUrl = 'continue_url',
  AccountSwitch = 'user_switched_account',
  RedirectUrl = 'redirect_url',
  RemoveUrl = 'remove_url',
  ExpiresIn = 'expires_in',
  AccessDeniedPage = 'access-denied-page',
  UuishlistLoginId = 'uuishlist_login_id',
}

export enum ProviderLocalStorageKey {
  MicrosoftTeamsProvider = 'microsoftteams',
  TeamsRefreshToken = 'uuishlist_ref_key'
}

export enum UserCookieStorageKey {
  LoginDebug = 'uuishlist_debug_key',
  LoginOriginal = 'uuishlist_key_',
  EnvLocalhost = 'localhost',
  EnvOrginal = '.enjoywishlist.com',
  LoginIdDebug = 'uuishlist_debug_login_id',
  LoginIdOriginal = 'uuishlist_login_id_'
}

export enum UserRole {
  Guests = 'Guests',
}